import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Login: React.FC = () => {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd]   = useState(false);
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const { login }               = useAuth();
  const history                 = useHistory();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(email, password);
      history.push('/dashboard');
    } catch (err: any) {
      setError(err?.response?.data?.message ?? 'Invalid email or password');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-split">
      {/* Left panel */}
      <div className="auth-left">
        <div className="auth-left-logo">
          <div className="auth-left-logo-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
            </svg>
          </div>
          <span className="auth-left-logo-text">Automately</span>
        </div>

        <div className="auth-left-hero">
          <h1 className="auth-left-headline">
            Close more deals.<br />Automatically.
          </h1>
          <p className="auth-left-sub">
            AI-powered CRM for Indian pharma &amp; SMB distributors.
          </p>
          <div className="auth-pills">
            {['AI Voice Qualification', 'WhatsApp Integration', 'Smart Calling Queue'].map(f => (
              <span className="auth-pill" key={f}>
                <span className="auth-pill-dot" />
                {f}
              </span>
            ))}
          </div>
        </div>

        <div className="auth-left-footer">
          Powered by Automately &middot; automately.net
        </div>
      </div>

      {/* Right panel */}
      <div className="auth-right">
        <div className="auth-form-card">
          <div className="auth-form-logo">
            <div className="auth-form-logo-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
              </svg>
            </div>
            <span className="auth-form-logo-text">Automately</span>
          </div>

          <h2 className="auth-heading">Welcome back</h2>
          <p className="auth-sub">Sign in to your workspace.</p>

          {error && <div className="auth-alert">{error}</div>}

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="auth-form-group">
              <label className="auth-label">Email address</label>
              <input
                className={`auth-input${error ? ' auth-input-error' : ''}`}
                type="email" value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@company.com"
                autoFocus required
              />
            </div>

            <div className="auth-form-group">
              <label className="auth-label">Password</label>
              <div className="auth-pwd-wrap">
                <input
                  className={`auth-input${error ? ' auth-input-error' : ''}`}
                  type={showPwd ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
                <button type="button" className="auth-pwd-toggle" onClick={() => setShowPwd(v => !v)} tabIndex={-1}>
                  {showPwd
                    ? <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                    : <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>}
                </button>
              </div>
            </div>

            <button type="submit" className="auth-btn" disabled={loading}>
              {loading ? <><span className="btn-spinner" />Signing in…</> : 'Sign in'}
            </button>
          </form>

          {/* <div className="auth-magic">
            <a href="#magic">Or sign in with magic link &rarr;</a>
          </div> */}

          <div className="auth-footer" style={{ marginTop: 20 }}>
            Don't have an account? Contact your admin.
          </div>
          {/* <div className="auth-footer" style={{ marginTop: 8, background: '#F7F7F7', padding: '8px 12px', borderRadius: 6 }}>
            Demo: <strong>admin@automately.net</strong> / <strong>password123</strong>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
